import { AppColors, AppPalette, CustomPalette } from "@bpipartners/webui";

const webshopPalette: AppPalette = {
  primary: {
    "0": "#000000",
    "5": "#000412",
    "10": "#000924",
    "20": "#040E2B",
    "25": "#071332",
    "30": "#091739",
    "35": "#0C1B40",
    "40": "#0E1F47",
    "50": "#102E5D", //new
    "60": "#132D45",
    "70": "#133951",
    "80": "#134562",
    "90": "#427291",
    "95": "#71A0C0",
    "98": "#A0CFEF",
    "99": "#E1EBF1",
    "100": "#FFFFFF",
  },
  secondary: {
    "0": "#000000",
    "5": "#001510",
    "10": "#002A20",
    "20": "#004434",
    "25": "#00533F",
    "30": "#00624A",
    "35": "#007156",
    "40": "#008062",
    "50": "#009475",
    "60": "#17A080",
    "70": "#23A98B",
    "80": "#2FB196",
    "90": "#59C3AB",
    "95": "#84D5C0",
    "98": "#AFEBD5",
    "99": "#D7F5EA",
    "100": "#FFFFFF",
  },
  tertiary: {
    "0": "#000000",
    "5": "#2B0A00",
    "10": "#3F1400",
    "20": "#662300",
    "25": "#7C2B00",
    "30": "#923300",
    "35": "#A83B00",
    "40": "#BE4300",
    "50": "#E46300",
    "60": "#FF7D1A",
    "70": "#FF9743",
    "80": "#FFB16D",
    "90": "#FFCB98",
    "95": "#FFE0C0",
    "98": "#FFF1E5",
    "99": "#FFF7F2",
    "100": "#FFFFFF",
  },
  neutral: {
    "0": "#000000",
    "5": "#0F0F0F",
    "10": "#1A1A1A",
    "20": "#2E2E2E",
    "25": "#383838",
    "30": "#424242",
    "35": "#4D4D4D",
    "40": "#575757",
    "50": "#717171",
    "60": "#8C8C8C",
    "70": "#A6A6A6",
    "80": "#C1C1C1",
    "90": "#DBDBDB",
    "95": "#EDEDED",
    "98": "#F0F6FF", //new
    "99": "#FCFCFC",
    "100": "#FFFFFF",
  },
  neutralVariant: {
    "0": "#000000",
    "5": "#0E1013",
    "10": "#191C20",
    "20": "#2E3135",
    "25": "#383B3F",
    "30": "#434649",
    "35": "#4E5154",
    "40": "#595C5F",
    "50": "#717376",
    "60": "#8A8C8F",
    "70": "#A4A6A9",
    "80": "#BFC1C3",
    "90": "#DADCDE",
    "95": "#ECEEF0",
    "98": "#F7F8F9",
    "99": "#FCFCFD",
    "100": "#FFFFFF",
  },
  error: {
    "0": "#000000",
    "5": "#2D0001",
    "10": "#410002",
    "20": "#690005",
    "25": "#7E0007",
    "30": "#93000A",
    "35": "#A80710",
    "40": "#BA1A1A",
    "50": "#DE3730",
    "60": "#FF5449",
    "70": "#FF897D",
    "80": "#FFB4AB",
    "90": "#FFDAD6",
    "95": "#FFEDEA",
    "98": "#FFF8F7",
    "99": "#FFFBFF",
    "100": "#FFFFFF",
  },
};

const webshopColors: AppColors = {
  primary: webshopPalette.primary[50],
  onPrimary: webshopPalette.primary[100],
  primaryContainer: webshopPalette.primary[90],
  onPrimaryContainer: webshopPalette.primary[100],
  secondary: webshopPalette.secondary[50],
  onSecondary: webshopPalette.secondary[100],
  secondaryContainer: webshopPalette.secondary[90],
  onSecondaryContainer: webshopPalette.secondary[10],
  tertiary: webshopPalette.tertiary[50],
  onTertiary: webshopPalette.tertiary[100],
  tertiaryContainer: webshopPalette.tertiary[90],
  onTertiaryContainer: webshopPalette.tertiary[10],
  error: webshopPalette.error[40],
  onError: webshopPalette.error[100],
  errorContainer: webshopPalette.error[90],
  onErrorContainer: webshopPalette.error[10],
  inversePrimary: webshopPalette.primary[80],
  primaryFixed: webshopPalette.primary[90],
  onPrimaryFixed: webshopPalette.primary[10],
  primaryFixedDim: webshopPalette.primary[80],
  onPrimaryFixedVariant: webshopPalette.primary[30],
  secondaryFixed: webshopPalette.secondary[90],
  onSecondaryFixed: webshopPalette.secondary[10],
  secondaryFixedDim: webshopPalette.secondary[80],
  onSecondaryFixedVariant: webshopPalette.secondary[30],
  tertiaryFixed: webshopPalette.tertiary[90],
  onTertiaryFixed: webshopPalette.tertiary[10],
  tertiaryFixedDim: webshopPalette.tertiary[80],
  onTertiaryFixedVariant: webshopPalette.tertiary[30],
  background: webshopPalette.neutral[99],
  onBackground: webshopPalette.neutral[5],
  outline: webshopPalette.neutral[50],
  outlineVariant: webshopPalette.neutral[80],
  shadow: webshopPalette.primary[0],
  scrim: webshopPalette.primary[0],
  inverseSurface: webshopPalette.neutralVariant[90],
  inverseOnSurface: webshopPalette.neutralVariant[10],
  surface: webshopPalette.neutral[95],
  onSurface: webshopPalette.neutral[10],
  surfaceVariant: webshopPalette.neutralVariant[95],
  onSurfaceVariant: webshopPalette.neutralVariant[10],
  surfaceDim: webshopPalette.neutral[70],
  surfaceBright: webshopPalette.neutral[100],
  surfaceContainerLowest: webshopPalette.neutral[98],
  surfaceContainerLow: webshopPalette.neutral[95],
  surfaceContainer: webshopPalette.neutral[90],
  surfaceContainerHigh: webshopPalette.neutral[80],
  surfaceContainerHighest: webshopPalette.neutral[70],
  backdrop: webshopPalette.primary[30],
  relation: { organization: "", person: "", tag: "" },
  planning: {},
  importance: {
    major: { fg: "#ef5350", bg: "#f2bdb4" },
    medium: { fg: "#ffa726", bg: "#e0bc96" },
    normal: { fg: "#6b6f73", bg: "#edf1f4" },
    low: { fg: "#66bb6a", bg: "#c8ffc6" },
  },
  surfaceTint: "",
  timesheet: {
    green: "",
    orange: "",
  },
};

export const colors: CustomPalette = {
  appColors: webshopColors,
  appPalette: webshopPalette,
  palette: {
    background: {
      default: webshopColors.background,
      paper: webshopColors.surfaceBright,
    },
    primary: {
      light: webshopColors.primary,
      main: webshopPalette.primary[60],
      dark: webshopColors.primary,
      contrastText: webshopColors.onPrimary,
    },
    secondary: {
      light: webshopColors.secondary,
      main: webshopPalette.secondary[60],
      dark: webshopColors.secondary,
      contrastText: webshopColors.onSecondary,
    },
  },
};
